import SignUp from "../SignUp";

import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import ServerElementsWithoutActions from "../ServerElements/components/ServerElementsWithoutActions";



const SignUpView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box>
        <Typography variant="h4">
          {t('common:text.signup_view_title')}
        </Typography>
        <SignUp />
      </Box>
      <ServerElementsWithoutActions groupName="Signup" />
    </>
  );
}

export default SignUpView;